/**
 * SearchBar Component
 * Sticky search bar with icon and controlled input
 * @component
 */

import React from 'react';
import { SearchBarProps } from '../types';

export const SearchBar: React.FC<SearchBarProps> = ({
  value,
  onChange,
  placeholder = 'Search by name or ranking...',
}) => {
  return (
    <div className="mb-12 sticky top-4 z-20">
      <div className="relative max-w-2xl mx-auto backdrop-blur-md bg-gray-800/50 border border-gray-700 rounded-full shadow-lg">
        <div className="absolute inset-y-0 left-0 pl-6 flex items-center pointer-events-none">
          <svg
            className="h-5 w-5 text-gray-400"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full bg-transparent text-white placeholder-gray-400 py-4 pl-14 pr-6 rounded-full focus:outline-none focus:ring-2 focus:ring-green-500 transition-shadow"
        />
      </div>
    </div>
  );
};
